let selectedSize = null;
let selectedLid = null;

// Handle size selection
document.querySelectorAll('.size-options').forEach(container => {
  container.addEventListener('click', function() {
    selectedSize = this.getAttribute('data-size');
    
    // Highlight the selected size
    document.querySelectorAll('.size-options').forEach(el => el.classList.remove('selected'));
    this.classList.add('selected');

    checkAndRedirect();
  });
});

// Handle lid selection
document.querySelectorAll('.lid-options').forEach(container => {
  container.addEventListener('click', function(e) {
    const lid = e.target.getAttribute('data-lid');
    if (lid) {
      selectedLid = lid;

      // Highlight the selected lid
      document.querySelectorAll('.lid-options').forEach(el => el.classList.remove('selected'));
      e.target.classList.add('selected');

      checkAndRedirect();
    }
  });
});

function checkAndRedirect() {
  // if (!selectedSize) return; // Size must be selected
  // if (!selectedLid) return;  // Lid must be selected
 if (!selectedSize) {
    const selectedSizeEl = document.querySelector('.size-options.selected');
    if (selectedSizeEl) {
      selectedSize = selectedSizeEl.getAttribute('data-size');
    }
  }

  if (!selectedLid) {
    const selectedlidEl = document.querySelector('.lid-options.selected');
    if (selectedlidEl) {
      selectedLid = selectedlidEl.getAttribute('data-lid');
    }
  }
  // Transformations
  const lidValue = selectedLid === "with_lid" ? "lid" : null;
  const sizeValue = selectedSize === "Full set" ? "4pcs" : selectedSize;

  // if (!lidValue) return; // Prevent redirect if lid is invalid

  const allLinks = document.querySelectorAll('.all_hive_products_link');
  for (let link of allLinks) {
    const linkSize = link.getAttribute('data-attr-size');
    const linkLid = link.getAttribute('data-attr-lid') || null;
    if (linkSize === sizeValue && linkLid === lidValue) {
      window.location.href = link.href;
      break;
    }
  }
}
